import React from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";

// assets
import BellIconDark from "assets/icons/bell-icon-dark.svg";
import BellIconLight from "assets/icons/bell-icon-light.svg";

const NotificationIcon = ({ mode = "dark" }) => {
  const navigate = useNavigate();
  const { unreadNotificationCount } = useSelector(
    (state) => state.notifications
  );

  return (
    <Icon onClick={() => navigate("/home/notifications")}>
      <img src={mode === "dark" ? BellIconDark : BellIconLight} />
      {unreadNotificationCount > 0 && (
        <Badge>
          {unreadNotificationCount < 100 ? unreadNotificationCount : "99+"}
        </Badge>
      )}
    </Icon>
  );
};

const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  outline: none;
  position: relative;
  &:hover {
    cursor: pointer;
  }

  min-width: 20px;
  min-height: 20px;
`;

const Badge = styled.span`
  position: absolute;
  left: 44%;
  bottom: 50%;

  width: auto;
  height: 16px;
  padding: 0 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background-color: #ff4747;
  font-size: 10px;
  font-weight: 600;
  line-height: 10px;
  color: #ffffff;
`;

export default NotificationIcon;
